import * as React from 'react';

import { useLocation, useNavigate } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';
import { useTracker } from '@coursera/event-pulse/react';

import TrackedButton from 'bundles/page/components/TrackedButton';

export type SignInModalButtonProps = {
  label: string;
  variant?: ButtonProps['variant'];
  onBtnClick?: () => void;
  className?: string;
};

const redirectUrl = '/onboarding?src=banner,frontpage';

const SignInModalButton = ({ label, variant = 'primary', onBtnClick, className }: SignInModalButtonProps) => {
  const track = useTracker();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    onBtnClick?.();

    track('click_button', {
      button: { name: 'hero_primary_cta' },
      pageSection: { sectionName: 'hero_banner' },
    });

    navigate(
      {
        pathname: location?.pathname || '/',
        search: '?authMode=signup',
      },
      { replace: true }
    );
  };

  return (
    <Button
      component={TrackedButton}
      requireFullyVisible={false}
      withVisibilityTracking={false}
      trackingName="banner_cta"
      data={{ copy: label, href: redirectUrl }}
      size="small"
      variant={variant}
      data-elementtiming="frontpage.banner.cta"
      data-testid="enroll-button"
      onClick={handleClick}
      className={className}
      iconPosition="after"
      icon={<ArrowNextIcon size="medium" />}
    >
      {label}
    </Button>
  );
};

export default SignInModalButton;
